var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('credit-scores',{attrs:{"report":_vm.report,"showAnchor":false}}),_vm._v(" "),_c('credit-history',{attrs:{"report":_vm.report}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }